export function validateNotEmpty(text: string) {
  return text && text.length != 0;
}

export function validatePassword(text: string, canBeEmpty?: boolean) {
  if (canBeEmpty && text.length == 0) return true;

  const test = passwordCaseStats(text);
  return (
    test.length && test.lower && test.numeric && test.upper && test.special
  );
}

export function validateEmail(email: string) {
  const re = /\S+@\S+/;
  return re.test(email) && email.indexOf(",") == -1; // keep the checking simple
}

export function passwordCaseStats(text: string) {
  return {
    lower: (text.match(/[a-z]/g) || []).length > 0,
    upper: (text.match(/[A-Z]/g) || []).length > 0,
    numeric: (text.match(/[0-9]/g) || []).length > 0,
    special:
      (text.match(/[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]/g) || []).length > 0,
    length: text.length >= 8,
  };
}
